
<div class="containerpadding">
 
  <div class="row d-flex justify-content-between">
    <div class="col-sm-11 col-lg-6">
      <div class="card">
        <div class="card-header backgrund-green">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <mat-icon aria-hidden="false" aria-label="Zahtjevi">task_alt</mat-icon> Aktivni radni nalozi <span *ngIf="lista">{{lista.length}}</span>
            </div>
            <div>
              <button (click)="NoviZahtjev()" mat-button class="add-color"><mat-icon aria-hidden="false" aria-label="Novi">add_task</mat-icon> Novi</button>&nbsp;
              <button (click)="UcitajOtvorene()" mat-button><mat-icon aria-hidden="false" aria-label="Osvježi">refresh</mat-icon> Osvježi</button>
            </div>
          </div>
        </div>
        <app-radni-nalog-input *ngIf="noviZahtjev" (newItemEvent)="addItem($event)"></app-radni-nalog-input>
        <app-radni-nalog-input *ngIf="ispravakNovog" [item]="currentItem" (newItemEvent)="editnewItem($event)"></app-radni-nalog-input>

        <ul *ngIf="lista" class="list-group list-group-flush">
          <li class="list-group-item" *ngFor="let zahtjev of lista">
            <mat-card-content>
              <div class="col-12 d-flex justify-content-between align-items-center">
                <h5 class="requesttitle">{{zahtjev.datumPrijave | date: 'dd.MM.yyyy'}} RN broj:{{zahtjev.rnbroj}}</h5>
                  <button (click)="IspraviNoviZahtjev(zahtjev.radniNalogId)" mat-button class="edit-color"><mat-icon aria-hidden="false" aria-label="Uredi">edit</mat-icon> Uredi</button>
                  <button (click)="openDialog(zahtjev.radniNalogId)" mat-button class="edit-color"><mat-icon aria-hidden="false" aria-label="Briši">delete_forever</mat-icon> Briši</button>                
              </div>
              <div class="col-12 mt-1">
                <h4 class="card-subtitle mb-2  requeststatus"> {{zahtjev.opisKvara}}</h4><br />
                Vrsta kvara/rada:{{zahtjev.kvar}}
                </div>
            </mat-card-content>
            <mat-card-actions>
              <mat-accordion class="example-headers-align" multi>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      Detalji
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <mat-form-field class="full-width">
                    <mat-label>Serviser</mat-label>
                    <input matInput disabled value="{{zahtjev.serviser}}">
                  </mat-form-field>
                  <mat-form-field class="full-width">
                    <mat-label>Korisnik</mat-label>
                    <input matInput disabled value="{{zahtjev.ime}} {{zahtjev.prezime}}">
                  </mat-form-field>
                  <mat-form-field class="full-width">
                    <mat-label>Adresa</mat-label>
                    <textarea matInput cdkTextareaAutosize disabled>{{zahtjev.mjesto}}, {{zahtjev.ulica}}</textarea>
                  </mat-form-field>
                  <mat-form-field class="full-width">
                    <mat-label>Izvršeni radovi</mat-label>
                    <textarea matInput cdkTextareaAutosize disabled>{{zahtjev.izvrsenOpisKvara}}</textarea>
                  </mat-form-field>
                </mat-expansion-panel>
              </mat-accordion>
            </mat-card-actions>
          </li>
        </ul>
      </div>



    </div>
    <div class="col-sm-11 col-lg-6">


      <div class="card">
        <div class="card-header backgrund-green">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <mat-icon aria-hidden="false" aria-label="Zatvoreni zahtjevi">check_circle_outline</mat-icon> Zatvoreni zahtjevi
            </div>
            <button (click)="OsvjeziZatvorene()" mat-button class="align-items-center"><mat-icon aria-hidden="false" aria-label="Osvježi">refresh</mat-icon> Osvježi</button>
          </div>
        </div>
        <ul *ngIf="listazatvoreni" class="list-group list-group-flush">
          <li *ngFor="let zatvoren of listazatvoreni" class="list-group-item">
            <h5 class="card-title d-flex justify-content-between align-items-center">
              {{zatvoren.datumPrijave | date: 'dd.MM.yyyy'}} {{zatvoren.rnbroj}}
              <span><button (click)="IspraviZahtjev(zatvoren.id)" mat-button class="edit-color"><mat-icon aria-hidden="false" aria-label="Novi">edit</mat-icon> Uredi</button></span>
            </h5>
            <p class="card-text">{{zatvoren.opisKvara}}</p>
            <mat-card-actions>
              <mat-accordion class="example-headers-align" multi>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      Detalji
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <mat-form-field class="full-width">
                    <mat-label>Serviser</mat-label>
                    <input matInput disabled value="{{zatvoren.serviser}}">
                  </mat-form-field>
                  <mat-form-field class="full-width">
                    <mat-label>Korisnik</mat-label>
                    <input matInput disabled value="{{zatvoren.ime}} {{zatvoren.prezime}}">
                  </mat-form-field>
                  <mat-form-field class="full-width">
                    <mat-label>Adresa</mat-label>
                    <textarea matInput cdkTextareaAutosize disabled>{{zatvoren.mjesto}}, {{zatvoren.ulica}}</textarea>
                  </mat-form-field>
                  <mat-form-field class="full-width">
                    <mat-label>Rješenje</mat-label>
                    <textarea matInput cdkTextareaAutosize disabled>{{zatvoren.izvrsenOpisKvara}}</textarea>
                  </mat-form-field>
                </mat-expansion-panel>
              </mat-accordion>
            </mat-card-actions>
            <requestsAdd *ngIf="ispravakZahtjeva" [item]="currentItem" (newItemEvent)="editItem($event)"></requestsAdd>
          </li>
        </ul>
        <button (click)="UcitajJos()" mat-button><mat-icon aria-hidden="false" aria-label="Osvježi">download</mat-icon>Učitaj još</button>
      </div>
    </div>
  </div>
</div>
